import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  withRouter,
} from '@ipc/ipc-core';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import './authInfo.scss';
import { getAuthState } from './redux/selectors/authInfoSelector';
import AMTUserManual from '../../downloadables/pdf/AMTUserManual.pdf';

const mapStateToProps = (state) => ({
  auth: getAuthState(state),
});

const Authenticated = () => (
  <div className="user-manual">
    <a href={AMTUserManual} target="_blank" rel="noreferrer" className="user-manual-container" style={{ color: '#575858' }} download="AMTUserManual.pdf">
      <FontAwesomeIcon icon="question-circle" className="icon" />
    </a>
  </div>
);

const NotAuthenticated = () => (
  <div />
);

export class UserManual extends React.Component {
  render() {
    const { history, auth } = this.props;

    return (
      auth.isAuthenticated() ? <Authenticated auth={auth} />
        : <NotAuthenticated history={history} />
    );
  }
}

UserManual.propTypes = {
  history: PropTypes.objectOf(PropTypes.shape),
  auth: PropTypes.objectOf(PropTypes.shape),
};

export default connect(mapStateToProps)(withRouter(UserManual));
